/**
 *  Default language file
 *
 *  Deze file wordt gebruikt om tekst te vertalen.
 *  Per regel wordt een stukje van de tekst vertaald.
 *  Alles voor de ':' NIET veranderen, hier wordt de tekst mee vertaald.
 *
 *  Voor elke taal een nieuw bestand maken met de landcode als naam (en.js, nl.js, fr.js en de.js)
 */
import de from 'vuetify/lib/locale/de'

export default {
  ...de,

  // Algemeen
  lang: {
    'English': 'Englisch',
    'Dutch': 'Niederländisch',
    'German': 'Deutsch',
    'Français': 'Französisch',
    'english': 'Englisch',
    'dutch': 'Niederländisch',
    'german': 'Deutsch',
    'french': 'Französisch'
  },

  userInfo: {
    'No vendor assigned': 'kein Lieferant zugeordnet'
  },

  noDataText: '',

  general: {
    name: 'Name',
    user: 'Benutzer Name',
    createdAt: 'Hergestellt in',
    createdBy: 'Erstellt von',
    lastSeen: 'Zuletzt gesehen',
    actions: 'Aktionen',
    imei: 'Imei',
    frameNumber: 'Rahmennummer',
    odo: 'Odo',
    tags: 'Tags',
    active: 'Target Gruppe',
    subscription: 'Abonnements',
    vendor: 'Lieferant',
    searched: 'Keine passenden Ergebnisse gefunden',
    search: 'Suche',
    total: 'Gesamt',
    types: {
      eBike: 'e-bike',
      eCargoBike: 'lastenrad',
      speedPedelec: 'schnelles pedelec',
      eMoped: 'e-moped',
      unregistered: 'UNREGISTRIERT',
      moped: 'moped',
      automobile: 'automobil',
      other: 'sonstiges'
    },
  },

  dataFooter: {
    itemsPerPageText: 'Artikel pro Seite:',
    itemsPerPageAll: 'Alle',
    nextPage: 'Nächste Seite',
    prevPage: 'Vorherige Seite',
    firstPage: 'Erste Seite',
    lastPage: 'Letzte Seite',
    pageText: '{0}-{1} von {2}'
  },

  messages: {
    created: 'erstellt',
    Created: 'Erstellt',
    deleted: 'gelöscht',
    Deleted: 'Gelöscht',
    updated: 'aktualisiert',
    Updated: 'Aktualisiert',

    confirmTitle: 'Sind Sie sicher?',
    confirmText: 'Sie sind dabei, {0} zu löschen. Sind Sie sicher, dass du weitermachen willst?',
    cancelButtonText: 'Abbrechen',
    confirmButtonText: 'Ja, {0}',

    confirmDelete: 'Löschen',

    confirmResolveText: 'Du bist dabei, {0} aufzulösen. Bist du dir sicher, dass du weitermachen willst?',
    confirmResolve: 'lösen Sie diesen Fall',
    confirmCloseText: 'Du bist dabei, {0} zu schließen. Bist du dir sicher, dass du weitermachen willst?',
    confirmClose: 'Schließen Sie diesen Fall',

    errorTitle: 'Upps!',
    errorMessage: 'Bei der Anfrage ist ein Fehler aufgetreten. {0}. Bitte kontaktieren Sie Tracefy für Hilfe.',
    successTitle: 'Juhuu!',
    successMessage: '{0} war erfolgreich {1}!'

  },

  Navigation: {
    home: 'Home',
    map: 'Karte',
    information: 'Informationen',
    installDevices: 'Geräte installieren',
    analytics: 'Analytik',
    businesses: 'Unternehmen',
    tags: 'Tags',
    reports: 'Berichte',
    entities: 'Einheiten',
    users: 'Benutzer',
    devices: 'Geräte',
    tokenManagement: 'API Tokens',
    subscriptions: 'Abonnements',
    subscriptionManagement: 'Abonnementverwaltung',
    maintenancePlans: 'Wartungspläne',
    notifications: 'Benachrichtigungen',
    missing: 'Fehlende Fahrräder',
    shop: 'Geschäft',
    maintenanceBanner: 'Geplante Wartungsarbeiten aus',
    endYearNotice: 'Möchten Sie das Jahresendangebot nutzen?',
    clickHere: 'Klicken Sie hier!',
    until: 'bis um'
  },

  Dashboard: {
    user: 'Wilkommen {0}',
    map: 'Karte',
    installDevices: 'Geräte installieren',
    information: 'Information',
    analytics: 'Analyse',
    businesses: 'Unternehmen',
    tags: 'Tags',
    reports: 'Berichte',
    entities: 'Einheiten',
    users: 'Benutzer',
    devices: 'Geräte',
    tokenManagement: 'API Tokens',
    subscriptions: 'Abonnements',
    subscriptionManagement: 'Abonnementverwaltung',
    maintenancePlans: 'Wartungspläne',
    notifications: 'Benachrichtigungen',
    missing: 'Fehlende Fahrräder',
    shop: 'Geschäft',
    version: 'Version',
    notice: {
      velofollies: 'Treffen wir uns am 20,21,22 Januar um'
    }
  },

  // Map View
  Map: {
    tools: {
      search: 'Suchen',
      showFleet: 'Flotte anzeigen'
    },
    sidebar: {
      reload: 'Herladen',
      loadMore: 'Mehr Reisen',
      trips: {
        title: 'Trips',
        dayTotals: 'Gesamt an diesem Tag: '
      },
      error: {
        noTrips: 'Sie haben noch keine Reisen.',
        noMarkers: 'Fehler beim Laden Ihrer Reise.'
      },
      information: {
        title: 'Information',
        lastLocation: 'Letzter Ort',
        noLastLocation: 'Kein letzter Ort',
        lastActivity: 'Letzte Aktivität',
        noLastActivity: 'Noch keine Aktivität',
        odoDistance: 'ODO Distanz',
        brand: 'Marke',
        noBrand: 'Keine Marke angegeben',
        model: 'Modell',
        noModel: 'Kein Modell angegeben',
        powerUnit: 'Antrieb',
        noPowerUnit: 'Kein Antrieb angegeben',
        vehicleType: 'Fahrzeugtyp',
        noVehicleType: 'Kein Fahrzeugtyp angegeben',
        imei: 'IMEI',
        vendor: 'Lieferant',
        noVendor: 'Nicht mit Lieferant verbunden',
        notApplicable: 'Unzutreffend'
      }
    }
  },

  InstallDevices: {
    title: 'Geräte installieren',
    infoGuideNotice: 'Diese Seite hat ein Update erhalten, schauen Sie sich den Neuzugang hier an',
    noticeBosch1: 'HINWEIS: Erkundigen Sie sich bei ',
    noticeBosch2: ' motoren der Stromversorgung werden mit der Bosch-Software aktiviert.',
    noticeConsumerInfo: '*Die E-Mail-Adresse und Telefonnummer dienen nur zu Verwaltungszwecken (wir versenden keine Aktivierungs-E-Mails an Kunden)',
    form: {
      title: {
        create: 'Neue Einheit erstellen',
        replace: 'Einheit ersetzen'
      },
      buttons: {
        returnForm: "Rücksendeformular",
      },
      tabs: {
        create: 'Neue Einheit erstellen',
        replace: 'Einheit ersetzen'
      },
      subTitles: {
        selectPlan: 'Wartungsplan auswählen',
        noPlansAvailable: 'Kein Wartungsplan gefunden.',
        selectTags: 'Beschriftungen auswählen'
      },
      placeholders: {
        imei: 'IMEI-Nummer eingeben ...',
        maintenanceplan: 'Wartungsplan',
        other: 'Anders',
        type: 'Fahrzeugtyp',
        brand: 'Marke',
        powerunit: 'Antrieb',
        model: 'Model',
        tagGroups: 'Einstellungen (Etikettengruppe)',
        availableEntities: 'Verfügbare Entitäten',
        tags: 'Tags',
        licensing: 'Lizenz',
        frameNumber: 'Rahmennummer',
        licensePlate: 'Nummernschild'
      },
      imei: {
        search: 'Suchen Sie eine IMEI-Nummer',
        searching: 'Suche, bitte warten',
        notFound: 'Kein Gerät gefunden',
        needNumbers: 'Entrez encore {0} numéro{1}',
        huyserImei: 'Aufmerksamkeit! Dieses Gerät ist für ein Huyser-Fahrrad bestimmt'
      },
      validation: {
        name: {
          required: 'Name ist erforderlich',
          length: 'Der Name besteht aus mindestens 4 Zeichen'
        },
        odo: {},
        device: {
          required: 'IMEI-Nummer ist erforderlich'
        },
        frame: {
          required: 'Rahmennummer ist erforderlich',
          length: 'Rahmennummer besteht aus mindestens 4 Zeichen'
        },
        customerInfoRequired: 'Kundeninformationen sind erforderlich',
        customerEmail: {
          valid: 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
        }
      },
      messages: {
        fillAllFields: 'Füllen Sie alle Felder aus',
        errorFromServer: 'Fehler vom Server',
        success: 'Einheit erstellt',
        typeBrandAreRequired: 'Typ und Marke sind erforderlich'
      },
      name: 'Name der Einheit',
      frameNumber: 'Rahmennummer',
      odo: 'Odo',
      metrics: 'Metrik',
      device: 'Gerät',
      groups: 'Gruppen',
      tags: 'Tags',
      actions: {
        create: 'Erstellen {0}',
        save: 'Speichern {0}',
        replace: 'Einheit ersetzen',
        cancel: 'Abbrechen',
        search: 'Suchen nach einem Gerät IMEI.'
      }
    },

    listTitle: 'Letzte 20 erstellte Einheiten',

    tooltips: {
      mapLocation: 'Ort auf Karte anzeigen',
      status: 'Status',
      delete: 'Löschen'
    }
  },

  ImeiStatus: {
    tab: 'Status',
    serviceStatus: 'Service status',
    serviceStatuses: {
      connecting: 'Verbinden',
      connected: 'Verbunden',
      live: 'Live'
    },
    consentDialog: {
      title: 'Haben Sie eine Kundeneinwilligung?',
      text: 'Diese Aktion erfordert die Anzeige des Standorts und der letzten Fahrten dieser Entität. Falls erforderlich, wird eine E-Mail an den Kunden gesendet, in der er darüber informiert wird, dass der Standort geteilt wird.',
      confirm: 'Ja, ich habe Zustimmung',
      cancel: 'Nein geh zurück'
    },
    headers: {
      entityInfo: 'Fahrzeuginfo',
      liveUpdates: 'Live-Tracker-Updates'
    },
    liveUpdates: {
      connectionError: 'Es konnte keine Verbindung zum Live-Dienst hergestellt werden',
      lastUpdate: 'Letztes Update',
      currentSpeed: 'Geschwindigkeit',
      heading: 'Überschrift',
      network: 'Netzwerk',
      GPS: 'GPS',
      externalBattery: 'Externe Batterie',
      connectedWaitingForUpdates: 'Warten auf Updates vom Tracker...',
      noPastLocations: 'ACHTUNG! Dieser Tracker hat keinen historischen Standort! Wahrscheinlich ist es nicht richtig angeschlossen!',
      makeSureBikeOutside: 'Bitte vergewissern Sie sich, dass das Fahrzeug draußen steht, eingeschaltet ist und sich kürzlich bewegt hat.',
      noUpdateNotice: 'Wenn nach 5 Minuten kein Update angezeigt wird, ist der Tracker wahrscheinlich falsch angeschlossen oder defekt.'
    },
    map: {
      connectingToService: 'Verbindung zum Dienst für Live-Updates herstellen...',
      customerEntityNotice: 'Standortinformationen können nicht angezeigt werden, da diesem Fahrzeug ein Kunde zugeordnet ist'
    },
    tooltips: {
      requestLocationUpdate: 'Fordern Sie eine Standortaktualisierung an',
      mapLocation: 'Standort auf Karte anzeigen',
      openInDebugView: 'Überprüfen Sie den Tracker auf der Debug-Seite',
      lastWaypointsStrongGps: 'Dieser Tracker hatte in den letzten 10 Wegpunkten ein starkes GPS-Signal',
      lastWaypointsMediumGps: 'Dieses Gerät hatte in den letzten 10 Wegpunkten ein mittelmäßiges GPS-Signal',
      lastWaypointsWeakGps: 'Dieses Gerät hatte in den letzten 10 Wegpunkten kein GPS-Signal',
      recentlyOnline: 'Dieser Tracker war in den letzten 24 Stunden online',
      notRecentlyOnline: 'Dieser Tracker war die letzten 24 Stunden offline',
      externalBatteryConnected: 'Die externe Batterie ist angeschlossen',
      externalBatteryDisconnected: 'Die externe Batterie ist abgeklemmt',
      strongGps: 'Starkes GPS-Signal',
      mediumGps: 'Mittleres GPS-Signal',
      weakGps: 'Schwaches GPS-Signal',
      networkConnected: 'Netzwerk verbunden',
      networkDisconnected: 'Kein Update länger als 3 Minuten'
    },
    noTripsToday: 'Heute keine Fahrten gefunden.'
  },

  Reports: {
    title: 'Berichte',
    periodic: {
      title: 'Regelmäßige Übersicht',
      target: 'Zielgruppe',
      request: 'Übersicht anfragen.',
      requestDone: 'Bericht erfolgreich eingereicht. Sie erhalten so schnell wie möglich eine E-Mail.',
      requestFail: 'Beim Anfordern Ihres Berichts ist ein Fehler aufgetreten. Bitte versuche es erneut.'
    },
    individual: 'Individuelle Übersicht',
    period: 'Periode',
    date: 'Daten',
    toolbar: {
      selectEntity: 'Einheit auswählen',
      selectUser: 'Benutzer auswählen',
      selectDates: 'Daten auswählen'
    },

    tooltips: {
      //
    },

    table: {
      headers: {
        startTime: 'Startzeit',
        startAddress: 'Startadresse',
        stopTime: 'Endzeit',
        stopAddress: 'Zieladresse',
        distance: 'Distanz',
        duration: 'Dauer',
        averageSpeed: 'Durchschnittsgeschwindigkeit',
        idle: 'Zeit auf Ort',
        name: 'Naam'
      },
      noDataText: 'Bitte geben Sie Ihren Datumsbereich an und wählen Sie eine Einheit oder einen Benutzer, um fortzufahren.'
    }
  },

  // Analytics View
  Analytics: {
    title: 'Analytik',
    toolbar: {
      addChart: 'Tabelle hinzufügen',
      addChartTip: 'Ein Tabelle mit der Schaltfläche + auf der rechten Seite erstellen, um hier eine Tabelle anzuzeigen.'
    },
    tooltips: {
      addChart: 'Tabelle hinzufügen'
    },
    dialog: {
      title: 'Tabelle hinzufügen',
      fields: {
        preset: 'Voreinstellung auswählen',
        targetGroup: 'Zielgruppe (optional)',
        dateRange: 'Daten auswählen'
      },
      actions: {
        create: 'Tabelle erstellen',
        save: 'Tabelle speichern',
        cancel: 'Abbrechen'
      }
    },
    queries: {
      activityDay: 'Aktivität abhängig von der Tageszeit (UTC-Zeit)',
      activityWeek: 'Aktivität abhängig vom Wochentag',
      averageDistancePerTrip: 'Durchschnittliche Distanz pro Trip',
      averageDurationPerTrip: 'Durchschnittliche Dauer pro Trip',
      averageSpeedPerTrip: 'Durchschnittsgeschwindigkeit pro Trip',
      totalDistancePerTrip: 'Gesamtdistanz pro Trip',
      totalDistancePerMonth: 'Gesamtdistanz pro Monat',
      totalDurationPerDay: 'Gesamtzeit pro Tag',
      totalDurationPerMonth: 'Gesamtzeit pro Monat',
      newEntitiesPerDay: 'Neue Einheiten pro Tag'
    }
  },

  // Vendor Management View
  VendorManagement: {
    tooltips: {
      edit: 'Bearbeiten {0}',
      delete: 'Löschen {0}'
    },
    toolbar: {
      search: 'Suche Lieferantenverzeichnis',
      noVendor: 'Lieferant wählen',
      options: 'Mehr Optionen',
      editVendor: 'Bearbeiten Sie {0}',
      createVendor: 'Lieferant erstellen',
      deleteVendor: 'Lösch {0}',
      createUser: 'Benutzer erstellen',
      linkToVendor: 'Einheit mit ein Lieferant verbinden',
      linkEntityToUser: 'Einheit mit Benutzer verbinden'
    },
    treeView: {
      noVendors: 'Keine Lieferanten gefunden'
    },
    dialog: {
      linkEntitiesToUser: 'Einheit mit Benutzer verbinden',
      linkItemsToUser: 'Mit Lieferanten verbinden',
      deleteVendor: 'Lösch Lieferant',
      createUserForVendor: 'Benutzer fur Lieferant erstellen',
      createVendor: 'Benutzer erstellen',
      editVendor: 'Lieferant bearbeiten',
      delete: {
        deleteUser: 'Benutzer löschen',
        areYouSure: 'Sind Sie sicher das Sie diese Benutzer löschen willen?',
        userDeleted: 'Benutzer erlöscht.',
        error: 'Bei der Anfrage ist ein Fehler aufgetreten. {0}. Bitte kontaktieren Sie Tracefy für Hilfe.'
      },
      update: {
        success: 'Benutzer bearbeitet.',
        error: 'Bei der Anfrage ist ein Fehler aufgetreten. {0}. Bitte kontaktieren Sie Tracefy für Hilfe.'
      },
      fields: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        address: 'Adresse',
        postcode: 'Postleitzahl',
        city: 'Stadt',
        phone: 'Telefon',
        email: 'E-Mail',
        role: 'Benutzer-Rolle',
        vendor: 'Lieferant',
        password: 'Temporäres Passwort',
      }
    },
    devicesTab: {
      title: 'Geräte',
      search: 'Suche Geräte',
      subtitle: 'Geräte fur {0}',
      headers: {
        name: 'Name',
        imei: 'IMEI',
        entityName: 'Einheit Name',
        vendor: 'Lieferant',
        lastSeen: 'Zuletzt gesehen',
        createdAt: 'Hergestellt in',
        location: 'Ort'
      }
    },
    entitiesTab: {
      title: 'Einheiten',
      search: 'Einheit suchen',
      subtitle: 'Einheit für {0}',
      headers: {
        name: 'Name',
        frameNumber: 'Rahmennummer',
        deviceImei: 'Gerät IMEI',
        vendorName: 'Lieferant name',
        userName: 'Consument',
        lastSeen: 'Zuletzt gesehen',
        subscription: 'Abonnement',
        createdAt: 'Hergestellt in',
        linkTo: 'Aktionen'
      }
    },
    usersTab: {
      title: 'Benutzer',
      search: 'Benutzer suchen',
      subtitle: 'Benutzer für {0}',
      headers: {
        name: 'Name',
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'Email',
        role: 'Rolle',
        vendor: 'Lieferant',
        lastSeen: 'Zuletzt gesehen',
        createdAt: 'Hergestellt in',
        updatedAt: 'Aktualisiert am',
        actions: 'Aktionen'
      }
    },

    dialogs: {
      actions: {
        create: 'Erstellen {0}',
        save: 'Speichern {0}',
        cancel: 'Abbrechen'
      },
      linkUser: {
        title: 'Einheiten mit Benutzer verbinden',
        fields: {
          select: 'Benutzer wählen'
        }
      },
      linkVendor: {
        title: 'Artikel mit einem Lieferanten verbinden',
        fields: {
          select: 'Lieferant wählen'
        }
      },
      createUser: {
        title: 'Benutzer für Lieferant erstellen',
        fields: {
          firstName: 'Vorname',
          lastName: 'Nachname',
          address: 'Adresse',
          postcode: 'Postleitzahl',
          city: 'Stadt',
          phone: 'Telefon',
          email: 'E-Mail',
          userRole: 'Benutzer-Rolle',
          role: 'Benutzer-Rolle',
          vendor: 'Lieferant',
          password: 'Temporäres Passwort',
          passwordHint: 'Doppelklicken Sie auf das Feld für ein neues Zufallspasswort'
        }
      },
      createVendor: {
        title: 'Lieferant erstellen',
        fields: {
          name: 'Name',
          address: 'Adresse',
          postcode: 'Postleitzahl',
          city: 'Stadt',
          country: 'Land',
          email: 'E-mail',
          phone: 'Telefon',
          vendor: 'Hauptlieferant'
        }
      },
      editVendor: {
        title: 'Lieferant bearbeiten',
        fields: {
          name: 'Name',
          address: 'Adresse',
          postcode: 'Postleitzahl',
          city: 'Stadt',
          country: 'Land',
          email: 'E-mail',
          phone: 'Telefon',
          vendor: 'Hauptlieferant'
        }
      }
    }
  },

  // Tag Management View
  TagManagement: {
    types: {
      general: 'Algemein',
      powerunit: 'Antrieb',
      type: 'Fahrzeugtyp',
      model: 'Model',
      brand: 'Marke',
      group: 'Gruppe',
      selected: 'Ausgewählt'
    },
    tagGroups: {
      model: {
        titleCase: {
          single: 'Tag Gruppe',
          plural: 'Tag Gruppen'
        },
        lowerCase: {
          single: 'tag Gruppe',
          plural: 'tag Gruppen'
        }
      },
      tooltips: {
        edit: 'Bearbeiten {0}',
        delete: 'Löschen {0}'
      },
      table: {
        buttons: {
          //
        },
        headers: {
          name: 'Gruppenname',
          tags: 'Tags in Gruppe',
          actions: 'Aktionen'
        }
      },
      dialog: {
        title: {
          create: 'Neue Tag Gruppe',
          edit: 'Tag Gruppe bearbeiten'
        },
        fields: {
          name: 'Gruppenname',
          tags: 'Tags'
        },
        actions: {
          create: 'Tag Gruppe erstellen',
          save: 'Tag Gruppe speichern',
          cancel: 'Abbrechen'
        }
      }
    },
    tags: {
      model: {
        titleCase: {
          single: 'Tag',
          plural: 'Tags'
        },
        lowerCase: {
          single: 'tag',
          plural: 'tags'
        }
      },
      tooltips: {
        edit: 'Bearbeiten {0}',
        delete: 'Löschen {0}'
      },
      toolbar: {
        search: 'Suche'
      },
      table: {
        buttons: {
          //
        },
        headers: {
          name: 'Tag Name',
          type: 'Typ',
          group: 'Gruppe',
          actions: 'Aktionen'
        }
      },
      dialog: {
        title: {
          create: 'Neue Tag Gruppe',
          edit: 'Tag Gruppe bearbeiten'
        },
        fields: {
          name: 'Name',
          type: 'Typ',
          groups: 'Gruppen'
        },
        actions: {
          create: 'Tag erstellen',
          save: 'Tag speichern',
          cancel: 'Abbrechen'
        }
      }
    }
  },

  // User Management View
  UserManagement: {
    model: {
      titleCase: {
        single: 'Benutzer',
        plural: 'Benutzer'
      },
      lowerCase: {
        single: 'Benutzer',
        plural: 'Benutzer'
      }
    },
    tooltips: {
      edit: 'Bearbeiten {0}',
      delete: 'Löschen {0}',
      tokens: 'Tokens',
      showEntities: 'Zeige Einheiten'
    },
    toolbar: {
      search: 'Suche'
    },
    table: {
      buttons: {
        //
      },
      headers: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        address: 'Adresse',
        postcode: 'Postleitzahl',
        city: 'Stadt',
        phone: 'Mobil',
        telephone: 'Telefon',
        email: 'E-mail',
        vendor: 'Lieferantenname',
        role: 'Rolle',
        actions: 'Aktionen'
      }
    },
    dialog: {
      title: {
        create: 'Neuer Benutzer',
        edit: 'Benutzer bearbeiten'
      },
      fields: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        address: 'Adresse',
        postcode: 'Postleitzahl',
        city: 'Stadt',
        phone: 'Mobil',
        telephone: 'Telefon',
        email: 'E-mail',
        userRole: 'Benutzerrolle',
        vendor: 'Lieferant',
        password: 'Temporäres Passwort',
        passwordHint: 'Doppelklicken Sie auf das Feld für ein neues Zufallspasswort'
      },
      actions: {
        create: 'Benutzer erstellen',
        save: 'Benutzer speichern',
        cancel: 'Abbrechen'
      }
    }
  },

  Tables: {
    customize: 'Tabelle anpassen'
  },

  EntityManagement: {
    model: {
      titleCase: {
        single: 'Einheit',
        plural: 'Einheiten'
      },
      lowerCase: {
        single: 'Einheit',
        plural: 'Einheiten'
      }
    },
    stepper: {
      add: 'Fügen Sie Tags zu Einheiten hinzu',
      addTags: 'Tags auswählen',
      overview: 'Overview',
      continue: 'Fortsetzen',
      save: 'Einreichen',
      back: 'Zuruck',
      cancel: 'Abbrechen',
      confirm: 'Sie werden die folgenden Tags an {0} {1} anhängen. Sind Sie sicher?'
    },
    missing: {
      confirm: 'Sie melden insgesamt {0} {1}. Sind Sie sicher?',
      report: 'Melden Sie eine fehlende Einheit',
      modalTitle: 'Bist du sicher?',
      modalText: 'Möchten Sie dieses Fahrzeug wirklich dem Bergungsdienst als vermisst melden?',
      uninsuredEntitiesWarning: 'Die folgenden Einheiten haben kein Abonnement und können nicht als fehlend gemeldet werden.',
      continue: 'Möchten Sie fortfahren?',
      tryAgain: 'Bitte versuchen Sie es mit einem anderen Unternehmen oder registrieren Sie sich für ein Abonnement.'
    },
    noOdo: 'n/a',
    csvModal: {
      title: 'Tabellendaten als CSV per E-Mail erhalten?',
      text: 'Innerhalb weniger Minuten wird die CSV an Ihre Benutzer-E-Mail gesendet.'
    },
    tooltips: {
      isCustomer: 'Kundenentität',
      ownEntity: 'Eigene Entität',
      csv: 'Tabellendaten per CSV anfordern',
      create: 'Neue Entität erstellen',
      tags: 'Tags hinzufügen',
      missing: 'Fehlende Entität melden',
      missingDisabled: 'Ermittlungsdienst deaktiviert, Interesse an diesem Dienst? Bitte kontaktieren Sie den Support'
    },
    toolbar: {
      title: {
        filtered: 'Zeigt {0} von {1} einheiten',
      },
      search: 'Suche'
    },
    table: {
      buttons: {
        view: '{0} ansehen'
      },
      headers: {
        name: 'Einheitenname',
        odo: 'ODO Distanz',
        subscription: 'Abonnement',
        targetGroup: 'Target Gruppe',
        lastSeen: 'Zuletzt gesehen',
        createdAt: 'Erstellt am',
        createdBy: 'Erstellt von',
        actions: 'Aktionen'
      }
    },
    dialog: {
      unregisteredEntityHelper: "Um eine nicht registrierte Einheit zu ändern, löschen Sie sie bitte und erstellen Sie eine neue mit der Funktion 'Geräte installieren'.",
      title: {
        create: 'Neue Einheit',
        edit: 'Einheit bearbeiten',
        details: 'Entitätsinformationen',
        tags: 'Etiketten auswählen'
      },
      fields: {
        name: 'Name',
        frameNumber: 'Rahmennummer',
        deviceImei: 'Gerät IMEI',
        vendor: 'Lieferant',
        targetGroup: 'Target Gruppe',
        odo: 'ODO',
        metrics: 'Metriken'
      },
      actions: {
        create: 'Einheit erstellen',
        save: 'Einheit speichern',
        cancel: 'Abbrechen'
      }
    }
  },

  // Maintenance Plans View
  MaintenancePlans: {
    title: 'Wartungspläne',
    toasts: {
      planned: 'Benachrichtigung planned',
      completed: 'Benachrichtigung marked complete',
      open: 'Benachrichtigung marked open',
      archived: 'Benachrichtigung archived',
      userAssigned: 'User assigned',
      userUnassigned: 'User unassigned'
    },
    tooltips: {
      createPlan: 'Wartungsplan erstellen',
      editPlan: 'Bearbeiten {0}',
      deletePlan: 'Löschen {0}',
      openPlan: '{0} Details anzeigen',
      activatePlan: 'Aktivieren {0}',
      deactivatePlan: 'Deaktivieren {0}',
      assignUser: 'Benutzer zuweisen',
      addDate: 'Datum hinzufügen',
      changeDate: 'Datum ändern',
      completeNotification: 'Vollständige Benachrichtigung',
      archiveNotification: 'Archivbenachrichtigung',
      showDetails: 'Zeige Details',
      hideDetails: 'Details ausblenden'
    },
    notification: {
      noOdo: 'Entity odo not found',
      noTrigger: 'No trigger assigned',
      noTriggerValue: 'No trigger value',
      noUser: 'No user assigned',
      noEntity: 'No entity assigned'
    },
    toolbar: {
      searchText: 'Suche',
      filterText: 'Filter',
      sortByText: 'Sortieren nach',
      plans: {
        sortOptions: {
          name: 'Name',
          createdAt: 'Hergestellt in'
        },
        filterOptions: {
          activated: 'Aktiviert',
          deactivated: 'Deaktiviert'
        }
      },
      notifications: {
        sortOptions: {
          entityName: 'Entitätsname',
          userName: 'Zugewiesener Benutzername',
          tiggerName: 'Triggername',
          createdAt: 'Hergestellt in',
          plannedAt: 'Geplanter Zeitpunkt'
        },
        filterOptions: {
          open: 'Geöffnet',
          done: 'Erledigt',
          archived: 'Archiviert'
        }
      }
    },
    planTabs: {
      info: {
        title: 'Information'
      },
      triggers: {
        title: 'Trigger',
        headers: {
          name: 'Name',
          value: 'Wert',
          metric: 'Metriken',
          actions: 'Aktionen'
        }
      },
      entities: {
        title: 'Einheiten',
        headers: {
          name: 'Name',
          tags: 'Tags',
          vendor: 'Lieferant',
          actions: 'Aktionen'
        }
      }
    },
    save: 'Speichern',
    close: 'Schließen',
    switchLabel: 'Aktiv',
    planDialog: {
      validationRules: {
        required: 'Der Plan muss eine {0} haben',
        maxLength: 'Die maximale Länge für die {0} ist {1} Zeichen.'
      },
      title: 'Wartungsplan bearbeiten',
      save: 'Speichern',
      close: 'Schließen',
      createTrigger: 'Neue Trigger erstellen',
      selectTrigger: 'Bestehenden Trigger auswählen',
      searchTextTrigger: 'Suche Trigger',
      searchTextEntity: 'Suche Einheiten',
      create: 'Wartungsplan bearbeiten',
      edit: 'Wartungsplan erstellen',
      description: 'Description',
      active: 'Activ',

      stepOne: {
        title: 'Plan-Details',
        subtitle: 'Titel und Beschreibung bearbeiten',
        titleText: 'Titel',
        descriptionTitle: 'Beschreibung'
      },
      stepTwo: {
        title: 'Einheiten',
        subtitle: 'Hinzufügen oder Entfernen von Einheiten für diesen Plan',
        allEntities: 'Alle Einheiten',
        searchText: 'Suche Einheitne',
        headers: {
          name: 'Name',
          frameNumber: 'Rahmennummer',
          tags: 'Tags',
          vendor: 'Lieferant'
        }
      },
      stepThree: {
        title: 'Trigger',
        subtitle: 'Hinzufügen oder Entfernen von Trigger für diesen Plan',
        searchText: 'Suche Trigger',
        headers: {
          name: 'Name',
          value: 'Wert',
          metric: 'Metriken',
          description: 'Beschreibung',
          actions: 'Aktionen'
        }
      }
    },
    noPlans: 'Noch keine Wartungspläne!',
    noPlanSearchResult: 'Keine Wartungspläne für Kriterien!',
    noNotifications: 'Noch keine Benachrichtigungen!',
    noNotificationSearchResult: 'Keine Benachrichtigungen für Kriterien!'
  },

  // Device Management View
  DeviceManagement: {
    model: {
      titleCase: {
        single: 'Gerät',
        plural: 'Geräte'
      },
      lowerCase: {
        single: 'Gerät',
        plural: 'Geräte'
      }
    },
    tooltips: {},
    toolbar: {
      title: {
        filtered: 'Zeigt {0} von {1} Geräte',
        total: 'Gesamt'
      },
      search: 'Suche',
      selected: 'Ausgewählt: {0} Geräte'
    },
    table: {
      buttons: {
        //
      },
      headers: {
        index: 'Index',
        title: 'Gerät',
        description: 'Beschreibung',
        imei: 'IMEI',
        iccid: 'ICCID',
        model: 'Model',
        firmwareVersion: 'Firmware Version',
        settingsCrc: 'Einstellungen CRC',
        entityName: 'Einheitenname',
        subVendorName: 'Lieferant',
        lastSeen: 'Zuletzt gesehen',
        createdAt: 'Erstellt am',
        actions: 'Aktionen'
      }
    },
    dialog: {
      title: {
        create: 'Neues Gerät',
        edit: 'Gerät bearbeiten'
      },
      fields: {
        title: 'Titel',
        description: 'Beschreibung',
        imei: 'IMEI',
        model: 'Modell',
        firmwareVersion: 'Firmware Version',
        settingsCrc: 'Einstellungen CRC',
        subVendorName: 'Sublieferant Name',
        lastSeen: 'Zuletzt gesehen',
        createdAt: 'Erstellt am'
      },
      actions: {
        create: 'Gerät erstellen',
        save: 'Gerät speichern',
        cancel: 'Abbrechen'
      }
    }
  },

  // Token Management View
  TokenManagement: {
    title: 'API Token management',
    model: {
      titleCase: {
        single: 'Benutzer',
        plural: 'Benutzer'
      },
      lowerCase: {
        single: 'Benutzer',
        plural: 'Benutzer'
      }
    },
    tooltips: {
      edit: 'Bearbeiten {0}',
      delete: 'Löschen {0}',
      tokens: 'Tokens'
    },
    toolbar: {
      search: 'Suche'
    },
    table: {
      buttons: {
        //
      },
      headers: {
        firstName: 'Vorname',
        lastName: 'Nachname',
        address: 'Adresse',
        postcode: 'Postleitzahl',
        city: 'Stadt',
        phone: 'Mobil',
        telephone: 'Telefon',
        email: 'E-mail',
        vendor: 'Lieferantenname',
        role: 'Rolle',
        actions: 'Aktionen'
      }
    },
    dialog: {
      title: {
        // Title is selected user.first_name + user.last_name
      },
      fields: {
        name: 'Token Name'
      },
      tokenList: {
        created: 'Erstellt: ',
        revoked: 'Widerrufen: '
      },
      actions: {
        create: 'Token erstellen',
        cancel: 'Abbrechen'
      }
    }
  },

  // Subscription Management View
  SubscriptionManagement: {
    model: {
      titleCase: {
        single: 'Abonnement',
        plural: 'Abonnements'
      },
      lowerCase: {
        single: 'Abonnement',
        plural: 'Abonnements'
      }
    },
    tooltips: {
      create: 'Abonnement erstellen',
      assign: 'Abonnement zuordnen',
      edit: 'Abonnement bearbeiten'
    },
    toolbar: {
      total: 'Gesamt',
      search: 'Suche'
    },
    tree: {
      subscriptionEmpty: 'Wählen Sie ein Abonnement'
    },
    table: {
      fields: {
        title: 'Titel',
        description: 'Beschreibung',
        currency: 'Währung',
        defaultPrice: 'Preis',
        discountPrice: 'Preis nach Rabatt',
        period: 'Intervall',
        periods: {
          year: 'Jährlich',
          month: 'Monatlich',
          quarter: 'Vierteljährlich'
        },
        actions: 'Aktionen'
      }
    },
    tabs: {
      enterprises: {
        title: 'Unternehmen',
        fields: {
          name: 'Name',
          actions: 'Aktionen'
        }
      },
      vendors: {
        title: 'Lieferanten',
        fields: {
          name: 'Name',
          actions: 'Aktionen'
        }
      },
      companies: {
        title: 'Firmen',
        fields: {
          name: 'Name',
          actions: 'Aktionen'
        }
      },
      departments: {
        title: 'Abteilungen',
        fields: {
          name: 'Name',
          actions: 'Aktionen'
        }
      }
    },
    dialog: {
      title: {
        create: 'Neues Abonnement',
        edit: 'Abonnement bearbeiten',
        vendor: 'Lieferanten abonnement'
      },
      fields: {
        title: 'Titel',
        description: 'Beschreibung',
        defaultAmount: 'Standardbetrag',
        discountAmount: 'Rabattbetrag',
        currency: 'Währung',
        period: 'Zeitraum',
        vendor: 'Lieferanten',
        noVendor: 'Wählen Sie einen Anbieter aus'
      },
      actions: {
        create: 'Neues Abonnement',
        save: 'Abonnement speichern',
        update: 'Aktualisieren Sie Anbieterabonnements',
        cancel: 'Abbrechen'
      }
    }
  },

  // Payment Management View
  PaymentManagement: {
    model: {
      titleCase: {
        single: 'Zahlung',
        plural: 'Zahlungen'
      },
      lowerCase: {
        single: 'Zahlung',
        plural: 'Zahlungen'
      }
    },
    tooltips: {},
    toolbar: {
      search: 'Suche'
    },
    table: {
      buttons: {
        save: 'Speichern',
        cancel: 'Abbrechen',
        close: 'Schließen'
      },
      headers: {
        actions: 'Aktionen',
        orderId: 'Bestell-ID',
        status: 'Status',
        user: 'Benutzer',
        brand: 'Marke',
        noUser: 'Benutzer nicht gefunden',
        entity: 'Einheit',
        noEntity: 'Einheit nicht gefunden',
        subscription: 'Abonnement',
        noSubscription: 'Abonnement nicht gefunden',
        noVendor: 'Kein Lieferant',
        paidAt: 'Bezahlt am',
        price: 'Preis',
        vendor: 'Lieferant',
        insurance: 'Versicherung',
        insuranceEnds: 'Endet',
        date: 'Endet'
      }
    },
    dialog: {
      title: 'Überblick',
      headers: {
        insurance: 'Versicherung',
        subscription: 'Abonnement',
        orderID: 'Bestell-ID',
        user: 'Benutzer',
        paidAt: 'Bezahlt am',
        entity: 'Einheit',
        insuranceStartDate: 'Angefangen',
        insuranceEndDate: 'Endet auf'
      }
    },
    confirmation: {
      text: {
        confirm: 'Sie sind dabei, Ihre Versicherung zu ändern. Sind Sie sicher?'
      }
    }
  },
  Information: {
    intro: {
      text: '',
      link: 'Suchen Sie unsere api Dokumentation?'
    },

    tabs: {
      installation: 'Installationsanleitung',
      portal: 'Portalsanleitung',
      app: 'Appsanleitung',
      marketing: 'Marketinginhalte'
    },
    videos: 'Video\'s',
    documents: 'Dokumenten',
    images: 'Abbildingen'
  },

  Shop: {
    addedToCart: 'In den Warenkorb gelegt!'
  }
}
